// @flow
import { defineMessages } from 'react-intl';

export const customisationErrors = defineMessages({
    fetchError: {
        id: 'dashboard.errors.fetch',
        defaultMessage: `Oops - We couldn’t load your custom dashboard at this time.`
    }
});



// WEBPACK FOOTER //
// ./src/core/state/dashboard/intl.js